import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  EnvironmentOutlined,
  HomeOutlined,
  InfoCircleOutlined,
  RadiusSettingOutlined,
  TagOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Modal } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import { useTranslation } from "react-i18next";
import { BiBed } from "react-icons/bi";

export const RoomDetailsModal = (props) => {
  const { show, handleClose, room } = props;
  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title style={{ color: "#443d80" }}>
          <strong>{room.name}</strong>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Carousel>
          {room.imageurls.map((url, index) => (
            <Carousel.Item key={index}>
              <img
                className="d-block w-100 bigimg"
                src={url}
                alt={`Slide ${index + 1}`}
              />
            </Carousel.Item>
          ))}
        </Carousel>
        <h5 className="mt-4" style={{ color: "#433d80" }}>
          <InfoCircleOutlined /> <strong>{t("room.description")}</strong>
        </h5>
        <p>{room.description}</p>
        <div className="room-details mt-4">
          <h5 style={{ color: "#433d80" }}>
            <HomeOutlined /> <strong>Room Information</strong>
          </h5>
          <div className="row">
            <div className="col-md-6">
              <p>
                <EnvironmentOutlined /> <strong>{t("room.view")}:</strong>{" "}
                {room.roomview}
              </p>
              <p>
                <BiBed />
                <strong>{t("room.bedding")}:</strong> {room.bedding}
              </p>
              <p>
                <RadiusSettingOutlined />
                <strong>{t("room.room_size")}:</strong> {room.roomsize} sq
                meters
              </p>
              <p>
                <TagOutlined /> <strong>{t("room.room_type")}:</strong>{" "}
                {room.type}
              </p>
            </div>
            <div className="col-md-6">
              <p>
                <UserOutlined /> <strong>{t("room.max_adults")}:</strong>{" "}
                {room.maxadult}
              </p>
              <p>
                <TeamOutlined /> <strong>{t("room.max_children")}:</strong>{" "}
                {room.maxchild}
              </p>
              <p>
                <CheckCircleOutlined /> <strong>{t("room.extra_bed")}:</strong>{" "}
                {room.extrabed ? "Yes" : "No"}
              </p>
              <p>
                {room.smokingpolicy ? (
                  <CheckCircleOutlined />
                ) : (
                  <CloseCircleOutlined />
                )}{" "}
                <strong>{t("room.smoking_policy")}:</strong>{" "}
                {room.smokingpolicy ? "Yes" : "No"}
              </p>
            </div>
          </div>
          <h5 className="mt-4" style={{ color: "#433d80" }}>
            <TagOutlined /> <strong>{t("room.facilities")}</strong>
          </h5>
          <div className="container">
            <div className="row">
              {room.facilities.map((facility, index) => (
                <div key={index} className="col-md-4">
                  <p>{facility}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {t("room.close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
